import { ApiData, getEntitiesPerStoreAsync, Query, ReportResource, Result } from '../Reports';

import { ApiOrderProductsAggregate, ApiOrderProductsField, TaxInfo } from './types';

export const parseApiDataToTaxInfo = (apiData: ApiData): TaxInfo => ({
  vat: Number(apiData[ApiOrderProductsField.SumLineTaxAmount]),
  name: String(apiData[ApiOrderProductsField.LineTaxRate] || ''),
  salesInclTax: Number(apiData[ApiOrderProductsField.SumLinePriceTaxIncluded]),
  salesExclTax: Number(apiData[ApiOrderProductsField.SumLinePriceTaxExcluded]),
  productType: String(apiData[ApiOrderProductsField.ProductType]),
});

export const getTaxesPerStoreAsync = async (query: Query): Promise<Result<TaxInfo>> =>
  getEntitiesPerStoreAsync<TaxInfo>(
    {
      ...query,
      resource: ReportResource.OrderProducts,
      aggregates: [ApiOrderProductsAggregate.TaxRate, ApiOrderProductsAggregate.ProductType],
      closedTillLimitation: true,
    },
    parseApiDataToTaxInfo,
  );
